"use client";

import { AntdRegistry } from "@ant-design/nextjs-registry";
import "@ant-design/v5-patch-for-react-19";
import { App, ConfigProvider } from "antd";

import { OCTOLANE_COLOR_TOKENS, OCTOLANE_DESIGN_TOKENS } from "./styles/tokens";

export default function AntProvider({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <AntdRegistry>
      <ConfigProvider
        theme={{
          token: {
            fontSize: 14,
            fontSizeSM: 12,
            fontSizeLG: 16,
            fontSizeXL: 18,
            colorPrimaryBorder: OCTOLANE_COLOR_TOKENS.border.light,
            colorPrimaryBorderHover: OCTOLANE_COLOR_TOKENS.border.base,
            colorPrimaryActive: OCTOLANE_COLOR_TOKENS.bg.dark,
            boxShadow: OCTOLANE_DESIGN_TOKENS.shadows.sm,
            colorTextSecondary: OCTOLANE_COLOR_TOKENS.text.light,
            colorPrimary: OCTOLANE_COLOR_TOKENS.bg.base,
            colorInfo: OCTOLANE_COLOR_TOKENS.text.base,
            colorTextBase: OCTOLANE_COLOR_TOKENS.text.base,
            colorPrimaryBgHover: OCTOLANE_COLOR_TOKENS.bg.light,
            colorPrimaryHover: OCTOLANE_COLOR_TOKENS.bg.dark,
            colorPrimaryBg: OCTOLANE_COLOR_TOKENS.bg.lighter,
            colorPrimaryText: OCTOLANE_COLOR_TOKENS.text.base,
            colorPrimaryTextHover: OCTOLANE_COLOR_TOKENS.text.dark,
            colorLink: OCTOLANE_COLOR_TOKENS.information.dark,
            colorLinkHover: OCTOLANE_COLOR_TOKENS.information.dark,
            colorLinkActive: OCTOLANE_COLOR_TOKENS.information.dark,
          },
          components: {
            Button: {
              colorPrimary: OCTOLANE_COLOR_TOKENS.bg.base,
              colorPrimaryBgHover: OCTOLANE_COLOR_TOKENS.bg.light,
              contentFontSizeSM: 12,
              colorErrorBg: OCTOLANE_COLOR_TOKENS.error.dark,
              colorErrorBgActive: OCTOLANE_COLOR_TOKENS.error.dark,
              colorErrorBgHover: OCTOLANE_COLOR_TOKENS.error.dark,
            },
            Form: {
              labelFontSize: 12,
              labelColor: OCTOLANE_COLOR_TOKENS.text.base,
              verticalLabelMargin: 0,
              verticalLabelPadding: 0,
              itemMarginBottom: 8,
              fontSize: 12,
            },
            Tooltip: {
              fontSize: 12,
            },
            Input: {
              activeShadow: OCTOLANE_DESIGN_TOKENS.shadows.sm,
              hoverBorderColor: OCTOLANE_COLOR_TOKENS.border.base,
              activeBorderColor: OCTOLANE_COLOR_TOKENS.border.dark,
              colorBorder: OCTOLANE_COLOR_TOKENS.border.light,
              colorText: OCTOLANE_COLOR_TOKENS.text.base,
            },
            InputNumber: {
              activeShadow: OCTOLANE_DESIGN_TOKENS.shadows.sm,
              hoverBorderColor: OCTOLANE_COLOR_TOKENS.border.base,
              activeBorderColor: OCTOLANE_COLOR_TOKENS.border.dark,
            },
            DatePicker: {
              activeShadow: OCTOLANE_DESIGN_TOKENS.shadows.sm,
            },
            Select: {
              fontSizeSM: 12,
              colorBorder: OCTOLANE_COLOR_TOKENS.border.light,
              colorPrimaryBorder: OCTOLANE_COLOR_TOKENS.border.light,
              colorPrimaryBorderHover: OCTOLANE_COLOR_TOKENS.border.light,
            },
            Segmented: {
              colorBgLayout: OCTOLANE_COLOR_TOKENS.bg.lightest,
            },
            Modal: {
              motionDurationMid: "0.05s",
              motionDurationSlow: "0.05s",
              motionDurationFast: "0.05s",
            },
            Popover: {
              motionBase: 0,
              motion: false,
              motionUnit: 0,
              motionDurationMid: "0s",
              motionDurationSlow: "0s",
              motionDurationFast: "0s",
            },
          },
        }}
      >
        <App>{children}</App>
      </ConfigProvider>
    </AntdRegistry>
  );
}
